export default __webpack_public_path__ + "static/media/ic7_plus_orange.6ab15b59.png";